<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { VueContentLoading } from "vue-content-loading";
import { mapActions, mapGetters } from "vuex";
import AlertError from "@/components/alert_error";
import seasonOptions from "../../../helpers/season_options";

import Group1 from "./chart/group-1.vue";
import Group2 from "./chart/group-2.vue";
import Group3 from "./chart/group-3.vue";
import Group4 from "./chart/group-4.vue";

export default {
  page: {
    title: "الاحصائيات",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    VueContentLoading,
    AlertError,
    Group1,
    Group2,
    Group3,
    Group4,
  },
  data() {
    return {
      title: "احصائيات عامة",
      items: [
        {
          text: "الرئيسية",
          href: "/",
        },
        {
          text: "الاحصائيات",
          active: true,
        },
      ],

      //Page errors.
      errors: [],
      showAlert: false,

      loadingContent: false,

      dateRanges: seasonOptions,
      selectedDateRange: null,
      
      statistic: null,
      dataGroup1: {},
      dataGroup2: {},
      dataGroup3: {},
      dataGroup4: {},
    };
  },
  computed: {
    ...mapGetters("ststistic", ["getStstistic"]),
  },
  methods: {
    handleError(error) {
      alert(error);
      this.showAlert = true;
      if (error.response.status == 422)
        this.errors = Object.values(error.response.data.errors);
      else
        this.errors = [
          `Error Code : ${error.response.status}  Message : ${error.response.data.message}`,
        ];
    },
    ...mapActions("ststistic", ["getAll"]),
    fetchAll() {
      this.loadingContent = false;

      this.getAll(this.selectedDateRange)
        .then(() => {
          this.statistic = this.getStstistic;

          // Set Data To Group1
          this.dataGroup1 = {
            gender: {
              maleParticipants: this.getStstistic.gender.find((x) => x.id == 1)
                .forms_count,
              femaleParticipants: this.getStstistic.gender.find((x) => x.id == 2)
                .forms_count,
            },
            main: {
              literatureTexts: this.getStstistic.forms_artist.find((x) => x.id == 1)
                .artists_count,
              arts: this.getStstistic.forms_artist.find((x) => x.id == 2).artists_count,
              media: this.getStstistic.forms_artist.find((x) => x.id == 3).artists_count,
            },
          };
          this.dataGroup1.gender.totalParticipants =
            this.dataGroup1.gender.maleParticipants +
            this.dataGroup1.gender.femaleParticipants;
          this.dataGroup1.main.totalArtwork =
            this.dataGroup1.main.literatureTexts +
            this.dataGroup1.main.arts +
            this.dataGroup1.main.media;

          // Set Data To Group2
          this.dataGroup2 = {
            barChart_series: [
              { data: this.getStstistic.education_level.map((x) => x.forms_count) },
            ],
          };
          this.dataGroup2.columnChart = {
            provinces: this.getStstistic.province.map((x) => x.province),
            series: [
              {
                name: "عدد الذكور",
                data: this.getStstistic.province.map((x) => x.male_count),
              },
              {
                name: "العدد الكلي",
                data: this.getStstistic.province.map((x) => x.total_count),
              },
              {
                name: "عدد الاناث",
                data: this.getStstistic.province.map((x) => x.female_count),
              },
            ],
          };
          this.dataGroup2.pieChart_series = [
            Number(this.getStstistic.age_statistics.children),
            Number(this.getStstistic.age_statistics.teenagers),
            Number(this.getStstistic.age_statistics.youngAdults),
            Number(this.getStstistic.age_statistics.adults),
            Number(this.getStstistic.age_statistics.middleAged),
            Number(this.getStstistic.age_statistics.elderly),
          ];

          // Set Data To Group3
          this.dataGroup3 = this.getStstistic.country.map((x) => {
            return {
              id: x.id,
              name: x.name_ar,
              total: x.forms_count,
              males: x.male_count,
              females: x.female_count,
            };
          });

          // Set Data To Group4
          this.dataGroup4 = {
            literatureTexts_series: this.getStstistic.forms_artist
              .find((x) => x.id == 1)
              .subs.map((x) => x.artists_count),
            arts_series: this.getStstistic.forms_artist
              .find((x) => x.id == 2)
              .subs.map((x) => x.artists_count),
            media_series: this.getStstistic.forms_artist
              .find((x) => x.id == 3)
              .subs.map((x) => x.artists_count),
          };

          this.loadingContent = true;
        })
        .catch((error) => {
          this.handleError(error);
          this.loadingContent = true;
        });
    },
  },
  created(){
    this.selectedDateRange = this.dateRanges[0].value;
    this.fetchAll()
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row mb-3">
      <div class="col-md-12">
        <label for="statistics-date-range">الفترة الزمنية</label>
        <select
          id="statistics-date-range"
          v-model="selectedDateRange"
          class="form-control select-p"
          @change="fetchAll"
        >
          <option
            v-for="dateRange in dateRanges"
            :key="dateRange.text"
            :value="dateRange.value"
          >
            {{ dateRange.text }}
          </option>
        </select>
      </div>
    </div>

    <AlertError :showDismissibleAlert="showAlert" :errors="errors"></AlertError>

    <div v-if="loadingContent">
      <Group1 :data="dataGroup1" />
      <Group4 :data="dataGroup4" />
      <Group2 :data="dataGroup2" />
      <Group3 :data="dataGroup3" />
    </div>

    <!-- loading content -->
    <div v-else>
      <vue-content-loading :rtl="true" :width="400" :height="582">
        <rect x="0" y="0" rx="5" ry="5" width="94" height="50" />
        <rect x="102" y="0" rx="5" ry="5" width="94" height="50" />
        <rect x="204" y="0" rx="5" ry="5" width="94" height="50" />
        <rect x="306" y="0" rx="5" ry="5" width="94" height="50" />

        <rect x="0" y="58" rx="5" ry="5" width="196" height="130" />
        <rect x="204" y="58" rx="5" ry="5" width="196" height="130" />

        <rect x="0" y="196" rx="5" ry="5" width="128" height="110" />
        <rect x="136" y="196" rx="5" ry="5" width="128" height="110" />
        <rect x="272" y="196" rx="5" ry="5" width="128" height="110" />

        <rect x="0" y="314" rx="5" ry="5" width="196" height="130" />
        <rect x="204" y="314" rx="5" ry="5" width="196" height="130" />

        <rect x="0" y="452" rx="5" ry="5" width="400" height="130" />
      </vue-content-loading>
      <vue-content-loading :rtl="true" :width="400" :height="110">
        <rect x="10" y="20" rx="5" ry="5" width="80" height="10" />
        <rect x="310" y="20" rx="5" ry="5" width="80" height="10" />

        <rect x="10" y="40" rx="2" ry="2" width="45" height="5" />
        <rect x="66" y="40" rx="2" ry="2" width="45" height="5" />
        <rect x="122" y="40" rx="2" ry="2" width="45" height="5" />
        <rect x="178" y="40" rx="2" ry="2" width="45" height="5" />
        <rect x="234" y="40" rx="2" ry="2" width="45" height="5" />
        <rect x="290" y="40" rx="2" ry="2" width="45" height="5" />
        <rect x="346" y="40" rx="2" ry="2" width="44" height="5" />
        <rect x="10" y="49" rx="1" ry="1" width="380" height="1" />

        <rect x="10" y="54" rx="2" ry="2" width="45" height="5" />
        <rect x="66" y="54" rx="2" ry="2" width="45" height="5" />
        <rect x="122" y="54" rx="2" ry="2" width="45" height="5" />
        <rect x="178" y="54" rx="2" ry="2" width="45" height="5" />
        <rect x="234" y="54" rx="2" ry="2" width="45" height="5" />
        <rect x="290" y="54" rx="2" ry="2" width="45" height="5" />
        <rect x="346" y="54" rx="2" ry="2" width="44" height="5" />
        <rect x="10" y="63" rx="1" ry="1" width="380" height="1" />

        <rect x="10" y="68" rx="2" ry="2" width="45" height="5" />
        <rect x="66" y="68" rx="2" ry="2" width="45" height="5" />
        <rect x="122" y="68" rx="2" ry="2" width="45" height="5" />
        <rect x="178" y="68" rx="2" ry="2" width="45" height="5" />
        <rect x="234" y="68" rx="2" ry="2" width="45" height="5" />
        <rect x="290" y="68" rx="2" ry="2" width="45" height="5" />
        <rect x="346" y="68" rx="2" ry="2" width="44" height="5" />
        <rect x="10" y="77" rx="1" ry="1" width="380" height="1" />

        <rect x="10" y="82" rx="2" ry="2" width="45" height="5" />
        <rect x="66" y="82" rx="2" ry="2" width="45" height="5" />
        <rect x="122" y="82" rx="2" ry="2" width="45" height="5" />
        <rect x="178" y="82" rx="2" ry="2" width="45" height="5" />
        <rect x="234" y="82" rx="2" ry="2" width="45" height="5" />
        <rect x="290" y="82" rx="2" ry="2" width="45" height="5" />
        <rect x="346" y="82" rx="2" ry="2" width="44" height="5" />
        <rect x="10" y="91" rx="1" ry="1" width="380" height="1" />

        <circle cx="177" cy="100" r="1" />
        <circle cx="187" cy="100" r="1" />
        <circle cx="200" cy="100" r="4" />
        <circle cx="213" cy="100" r="1" />
        <circle cx="223" cy="100" r="1" />
      </vue-content-loading>
    </div>
  </Layout>
</template>
